import * as React from 'react';
import { IconProps } from 'vet-bones/design-system/components';

export const CloudChecked: React.VFC<IconProps> = ({ size }) => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10469_508)">
        <path
          d="M12 5.25C12.3803 5.24993 12.7597 5.28761 13.1325 5.3625C14.3107 5.58816 15.3943 6.16182 16.2432 7.00942C17.0921 7.85702 17.6675 8.93964 17.895 10.1175L18.09 11.13L19.1025 11.31C20.1252 11.4859 21.044 12.0407 21.6757 12.8639C22.3075 13.6871 22.6058 14.7181 22.5112 15.7515C22.4165 16.7848 21.9359 17.7445 21.1652 18.4393C20.3944 19.134 19.3901 19.5128 18.3525 19.5H5.62502C4.58744 19.5128 3.58315 19.134 2.81239 18.4393C2.04163 17.7445 1.56102 16.7848 1.46639 15.7515C1.37177 14.7181 1.67007 13.6871 2.30182 12.8639C2.93358 12.0407 3.85237 11.4859 4.87502 11.31L5.88002 11.13L6.07502 10.1175C6.33934 8.74223 7.0764 7.50274 8.15851 6.61376C9.24062 5.72479 10.5996 5.24234 12 5.25ZM12 3.75C10.2545 3.74855 8.56311 4.356 7.21733 5.46766C5.87156 6.57933 4.95569 8.12559 4.62752 9.84C3.24627 10.0901 2.00844 10.8476 1.15714 11.9637C0.305848 13.0798 -0.0973822 14.4738 0.0266531 15.8721C0.150688 17.2703 0.793025 18.5716 1.8275 19.5204C2.86197 20.4692 4.21382 20.997 5.61752 21H18.3675C19.7712 20.997 21.1231 20.4692 22.1576 19.5204C23.192 18.5716 23.8344 17.2703 23.9584 15.8721C24.0824 14.4738 23.6792 13.0798 22.8279 11.9637C21.9766 10.8476 20.7388 10.0901 19.3575 9.84C19.075 8.36536 18.3564 7.00945 17.2948 5.94777C16.2331 4.88608 14.8772 4.16749 13.4025 3.885C12.9401 3.79725 12.4707 3.75206 12 3.75Z"
          fill="currentColor"
        />
        <path
          d="M11 15.1925L9.0575 13.25L8 14.3075L11 17.3075L16.25 12.0575L15.1925 11L11 15.1925Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10469_508">
          <rect fill="white" height="24" width="24" />
        </clipPath>
      </defs>
    </svg>
  );
};
